module.exports = __webpack_public_path__ + "static/media/nomination_email_example.335db9e0.png";